import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CellClickedEvent } from 'ag-grid-community';
import { UserService } from 'src/app/Core/services/user.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionDeferComponent } from 'src/app/Core/components/Layout/Panel/subscription-defer/subscription-defer.component';

@Component({
  selector: 'app-user-info-all',
  templateUrl: './user-info-all.component.html',
  styleUrls: ['./user-info-all.component.css'],
  providers: [DatePipe]
})
export class UserInfoAllComponent implements OnInit {
  userID: string = '';
  public user: any;
  // private bearerToken =
  //   '797f7ade7918222a85468248c79076a8819cf8b39bcd2d83a6d7c1598e8e6aad';
  pageLoaded: boolean = false;
  userInfoToggle: boolean = true;
  deviceTypesToggle: boolean = false;
  filteredDevices: any;
  dateFormat: string = 'dd MMM yyyy h:mm:ss a zzzz'


  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private userService: UserService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userID = params.get('id') || '';
      this.fetchUserData();
      this.pageLoaded = true;
    });
  }

  onCellClicked(event: CellClickedEvent): void {
    this.router.navigate(['/user-detail', this.userID]);
  }

  fetchUserData() {
    this.userService.getUserDataByUserID(this.userID).subscribe(
      (data) => {
        this.user = data;
        // You may need to adjust the property name based on your API response
      },
      (error) => {
        console.error('Error fetching user data:', error);
      }
    );
  }

  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr.replace(/_/g, ' ');
  }

  navigateToSubscriptionHistory() {
    this.router.navigate(['/subscription-history', this.userID]);
  }

  showDeferPopup() {
    this.dialog.open(SubscriptionDeferComponent, {
      width: '40%',
      data: {
        message: this.user.biller,
        userID: this.userID
      }
    });
  }

  getSubscriptionType(productId: string) {
    const type = productId === 'kiddeiaqaasmonth_stag' || productId === 'kiddeiaqaasmonth_stage' || productId === 'kiddeiaqaasmonth' ? 'Monthly'
      : productId === 'kiddeiaqaasyear_stage' || productId === 'kiddeiaqaasyear_stag' || productId === 'kiddeiaqaasyear' ? 'Yearly'
        : productId;
    return type;
  }
}
